export const MASK_SMS_CODE = '____';
export const MASK_CONTRACT_NUMBER = '______________';
export const MASK_BANK_ACC_CHANGE_SMS_CODE = '______';
export const BANK_ACCOUNT_NUMBER = 'XXX-XXX-XXXXXXXXXXXX-XX';
export const BANK_CARD_NUMBER = 'XXXX XXXX XXXX XXXX';
export const DNI_NUMBER = 'XXXXXXXX-X';
export const PHONE_MASK = 'XXX XXX XXX';
export const EXPIRE_AT_MASK = 'XX/XX';
